import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { fetchRestaurantPageData } from 'shared/store/restaurant'
import { Card } from 'app-v2/design-systems/components/containers/card'
import { H6 } from 'app-v2/design-systems/typography/titles'
import { Spacer } from 'app-v2/design-systems/components/Spacer/Spacer'
import { COLOR, ORIENTATION, SIZE } from 'app-v2/design-tokens'
import { BodyText } from 'app-v2/design-systems/typography/text'

import { Logo } from 'app-v2/assets/icons'
import {
    StyledCardContainer,
    StyledInfoContainer,
    StyledLine,
    StyledRestaurantInfoContainer
} from 'app-v2/modules/king-table/features/welcome-screen/components/table-card/styles'
import { OpeningStatus } from 'app/common/restaurant'
import { useTableStatus } from '../../hooks'
import { TableStatus } from './TableStatus'
import { Spinner } from 'app/assets/icons'

type TableCardProps = {
    restaurantPath: string,
    table: string,
    terrace: boolean
}

export const TableCard = ({
    restaurantPath,
    table,
    terrace
}: TableCardProps) => {
    const intl = useIntl()
    const d = useDispatch()

    const { restaurant } = useSelector(
        (state: RootState) => state.restaurantPageState
    )

    useEffect(() => {
        !!restaurantPath && d(fetchRestaurantPageData(restaurantPath))
    }, [d, restaurantPath])

    const status = useTableStatus(terrace)

    return (
        <StyledCardContainer>
            <Card center>
                <H6>
                    {intl.formatMessage({
                        id: 'ecommerce.kingtable.welcome.title'
                    })}
                </H6>
                <Spacer size={SIZE.XS} />
                <TableStatus tableNumber={table} status={status} />
                <Spacer size={SIZE.L} />
                <StyledLine />
                <Spacer />
                {status === 'LOADING' && !restaurant && (
                    <Spinner color={COLOR.PRIMARY} size={50} />
                )}
                {!!restaurant && (
                    <StyledRestaurantInfoContainer>
                        <Logo size={24} background={'transparent'} />
                        <Spacer
                            size={SIZE.XS}
                            orientation={ORIENTATION.HORIZONTAL}
                        />
                        <StyledInfoContainer>
                            <BodyText capitalize>
                                {restaurant.name
                                    .replace(/^burger king\s*/i, '')
                                    .toLowerCase()}
                            </BodyText>

                            <OpeningStatus
                                id={restaurant.id}
                                status={restaurant.status}
                                openingHour={restaurant.openingHour}
                                closingHour={restaurant.closingHour}
                            />
                        </StyledInfoContainer>
                    </StyledRestaurantInfoContainer>
                )}
            </Card>
        </StyledCardContainer>
    )
}
